module.exports = __webpack_public_path__ + "static/media/SA.8a5cc711.jpg";